// extracted by mini-css-extract-plugin
module.exports = {"button":"PoCompleteOrdersButton_button__Z9ABz","button-ltr":"PoCompleteOrdersButton_button-ltr__33ZpA"};